export default __webpack_public_path__ + "static/media/010-headband.88f6cc1c.svg";